import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import MediaFrame from "@/components/feature/MediaFrame";
import { pickUpItems } from "@/mocks/treatments";

export default function PickUp() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="u-container">
        <Reveal>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
            <SectionHeading en="PICK UP" jp="PICK UP TREATMENT" />
            <p className="max-w-sm text-[13px] leading-[2] text-foreground-700">
              季節やおすすめの施術を、こちらでご紹介しています。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:mt-14 sm:grid-cols-2 lg:grid-cols-3">
          {pickUpItems.map((item, index) => (
            <Reveal key={item.id} delay={index * 90}>
              <Link to={item.href} className="group flex h-full flex-col">
                <div className="relative">
                  <MediaFrame
                    src={item.image}
                    alt={item.imageAlt}
                    objectPosition={item.objectPosition}
                    className="h-[200px] w-full md:h-[230px]"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-primary-600 px-3 py-1 text-[10px] tracking-[0.2em] text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col border-b border-background-300/80 px-1 pb-6 pt-6">
                  <span className="font-label text-[10px] tracking-[0.25em] text-secondary-600">{item.label}</span>
                  <span className="en-eyebrow mt-3 block text-[10px] text-foreground-500">{item.en}</span>
                  <h3 className="mt-2.5 font-heading text-lg text-foreground-950">{item.jp}</h3>
                  <p className="mt-4 flex-1 text-[13px] leading-[2] text-foreground-700">{item.text}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[12px] text-foreground-900 transition-colors group-hover:text-accent-700">
                    詳しく見る
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}